'use client';

import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';

import { ResourceTypes } from './resourceTypes';

const wipResourceTypes = [
  ResourceType.ResourceTypeUnspecified,
  ResourceType.AwsEfs,
  ResourceType.AwsFsx,
  ResourceType.AwsRedshift,
  ResourceType.AzureFileShare,
  ResourceType.AzureDisk,
  ResourceType.AzureSapHanaVm,
  ResourceType.AzureSqlDatabase,
  ResourceType.AzureSqlManagedInstance,
  ResourceType.AzureMysql,
  ResourceType.AzurePostgresql,
  ResourceType.AzureCosmosdbMongodb,
  ResourceType.AzureCosmosdbNosql,
  ResourceType.AzureAksNamespace,
  ResourceType.GcpGkeNamespace,
  ResourceType.GcpCloudFirestore,
];

export const useSupportedResourceTypes = (
  cloudProviders: Provider[] = []
): ResourceType[] => {
  const { isDemo, isDev } = useEnvironment();
  const {
    FSxSupport,
    AzureSqlDatabaseSupport,
    SapHanaPitrSupport,
    AwsRedshiftDiscoverySupport,
  } = useFeatureFlags();

  return useMemo(() => {
    const ffResources = [
      ...(FSxSupport ? [ResourceType.AwsFsx, ResourceType.AwsEfs] : []),
      ...(AzureSqlDatabaseSupport ? [ResourceType.AzureSqlDatabase] : []),
      ...(SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm] : []),
      ...(AwsRedshiftDiscoverySupport ? [ResourceType.AwsRedshift] : []),
    ];

    return Object.values(ResourceType).filter(
      (x) =>
        x !== ResourceType.ResourceTypeUnspecified &&
        (cloudProviders.length
          ? cloudProviders.includes(ResourceTypes[x]?.provider)
          : true) &&
        (isDemo ||
          isDev ||
          !wipResourceTypes.includes(x) ||
          ffResources.includes(x))
    );
  }, [
    FSxSupport,
    AzureSqlDatabaseSupport,
    SapHanaPitrSupport,
    AwsRedshiftDiscoverySupport,
    isDemo,
    isDev,
    cloudProviders,
  ]);
};
